import { render, staticRenderFns } from "./primary.vue?vue&type=template&id=5e94a414"
import script from "./primary.vue?vue&type=script&lang=js"
export * from "./primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports